import React, { type SyntheticEvent } from "react";
import * as Styles from "./styles/MobileFooterStyles";
import Preloader, * as PreloaderStyles from "../../../../../../../common-deprecated/styles/v2/lexus/custom/Preloader";
import { buyCar, reserveCar } from "../../../../../../../common-deprecated/redux/actions/UtilActions";
import useCtaList from "../../../../hooks/shared/actions/useCtaList";
import useSiblingStepLink from "../../../../hooks/shared/actions/useSiblingStepLink";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../../redux/store";
import { NavStep } from "../../../../../shared-logic/utils/Navigation";
import { BnbLabel, useBnbOptionalLabel } from "../../../../utils/labels";
import { trackCtaCheckout, trackNavGoToStep } from "../../../../utils/tracking";
import CtaButton from "../cta/CtaButton";
import type { FinanceOptionType } from "../../../../../../../common-deprecated/types/CommonTypes";
import ButtonPrimary from "../../../../../../../common-deprecated/components/aem/lexus/button/ButtonPrimary";
import { useDispatch } from "../../../../../../../shared-logic/redux/store";

type MobileNextProps = {
    step: NavStep;
    financeOption: FinanceOptionType;
};

export const MobileNextButton = ({ step, financeOption }: MobileNextProps): JSX.Element | null => {
    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const nextStepLink = useSiblingStepLink("next");

    const ctas = useCtaList("summaryBasketCta");
    const config = useBnbSelector((state) => state.save);

    const [reserveNowLabel, reserveNowMonthlyLabel] = useBnbOptionalLabel([
        "reserveReserveNow",
        "reserveReserveNowMonthly",
    ]);
    const reserveLabel =
        financeOption === "monthly" && reserveNowMonthlyLabel
            ? "reserveReserveNowMonthly"
            : reserveNowLabel
              ? "reserveReserveNow"
              : null;

    const tyCodeSaving = config.saving || config.error;

    const onBuyCar = (): void => {
        trackCtaCheckout(step, "online-retailing-checkout");
        dispatch(buyCar());
    };

    const onReserveCar = (): void => {
        trackCtaCheckout(step, "online-retailing-checkout-reservation");
        dispatch(reserveCar());
    };

    return (
        <>
            {step === NavStep.Summary ? (
                <>
                    {tyCodeSaving ? (
                        <PreloaderStyles.PreLoaderWrapper hasBorder hasButtonHeight>
                            <Preloader size={30} />
                        </PreloaderStyles.PreLoaderWrapper>
                    ) : (
                        !!ctas[0] && (
                            <CtaButton linkWithoutIcon linkType="primary" config={ctas[0]}>
                                {ctas[0].title}
                            </CtaButton>
                        )
                    )}
                </>
            ) : (
                nextStepLink && (
                    <ButtonPrimary
                        data-testid="next-button"
                        href={nextStepLink.url}
                        onClick={(event: SyntheticEvent) => {
                            trackNavGoToStep(step, nextStepLink.step);
                            nextStepLink.go(event);
                        }}
                        linkWithoutIcon
                    >
                        <Styles.Clamp>{nextStepLink.label}</Styles.Clamp>
                    </ButtonPrimary>
                )
            )}

            {/* buy and reserve step don't have a next step, so it's fine to render them here and avoid code complexity  */}
            {step === NavStep.Buy && (
                <ButtonPrimary onClick={onBuyCar} fullWidth linkWithoutIcon>
                    <Styles.Clamp>
                        <BnbLabel
                            label={financeOption === "cash" ? "buyBuyNow" : "buyBuyNowMonthly"}
                            fallbackLabel="buyBuyNow"
                        />
                    </Styles.Clamp>
                </ButtonPrimary>
            )}
            {step === NavStep.Reserve && reserveLabel && (
                <ButtonPrimary onClick={onReserveCar} fullWidth linkWithoutIcon>
                    <Styles.Clamp>
                        <BnbLabel label={reserveLabel} />
                    </Styles.Clamp>
                </ButtonPrimary>
            )}
        </>
    );
};
